export enum VulnerableActivityEnum {
  ARI = 1,
  JYS = 2,
  TSC = 3,
  TPP = 4,
  TDR = 5,
  CHV = 6,
  MPC = 7,
  INM = 8,
  MJR = 9,
  OBA = 10,
  VEH = 11,
  BLI = 12,
  TCV = 13,
  SPR = 14,
  FEP = 15,
  DON = 16,
  ADU = 17,
  DIN = 18,
  INMC = 19,
  INMI = 20,
}
